import React from 'react'
import { useAuth } from '../context/AuthContext'
import type { Role } from '../lib/types'

const ROLE_LABELS: Record<Role, string> = {
  super_admin: 'an ATUUNE admin',
  atuune_admin: 'an ATUUNE admin',
  practice_owner: 'a practice owner',
  practice_admin: 'a practice admin',
  provider: 'a provider',
  patient: 'a patient',
}

/** Public signup/find-care flows must never silently reuse or overwrite an
 * existing session (admin or otherwise) — rendering this instead of the
 * form is how each flow enforces that it is a logged-out entry point. */
export function AlreadySignedInNotice({ continueAs }: { continueAs: string }) {
  const { me, logout } = useAuth()
  if (!me) return null

  return (
    <div className="auth-shell warm-theme">
      <div className="auth-card">
        <h1>You're already signed in</h1>
        <p className="muted" style={{ fontSize: 13.5 }}>
          You are signed in as {ROLE_LABELS[me.role] || me.role} ({me.email}). Sign out to continue as {continueAs}.
        </p>
        <button className="btn full" type="button" onClick={logout}>Sign out</button>
      </div>
    </div>
  )
}
